<div *ngIf="emergencyBanners.length > 0">
  <div class="mt-1 mb-1" *ngFor="let emergencyBanner of emergencyBanners">
    <div class="outage-banner" [style.background-color]="emergencyBanner.noteClass ? emergencyBanner.noteClass : ''">
      <div class="container pt-1">
        <div style="display: flex; justify-content: start">
          <i [ngClass]="emergencyBanner.iconClass || ''">&nbsp;</i>
          <h2>{{ emergencyBanner.title }}</h2>
        </div>
        <p style="margin: 0" class="unwantedP" [innerHTML]="emergencyBanner.body || '' | mdToHtml"></p>
      </div>
      <!-- </div> -->
    </div>
  </div>
</div>
